/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ShoppingBasketValidationErrorItemCategoryEnum = {
    AssistedRefund: 'assisted_refund',
    AxaInsurance: 'axa_insurance',
    Bags: 'bags',
    BookingRestore: 'booking_restore',
    CarrierItineraryChange: 'carrier_itinerary_change',
    ExtrasOther: 'extras.other',
    ExtrasPassengerDetailsChange: 'extras.passenger_details_change',
    FareLock: 'fare_lock',
    FlightEvent: 'flight_event',
    Guarantee: 'guarantee',
    HandlingFee: 'handling_fee',
    ItineraryChange: 'itinerary_change',
    Meals: 'meals',
    PassengerDetailsChange: 'passenger_details_change',
    PriceChange: 'price_change',
    PriorityBoarding: 'priority_boarding',
    Seating: 'seating',
    ServiceAllocatedSeating: 'service.allocated_seating',
    ServiceBaggage: 'service.baggage',
    ServiceInfant: 'service.infant',
    ServiceMealsOnBoard: 'service.meals_on_board',
    ServiceMusicalEquipment: 'service.musical_equipment',
    ServiceOther: 'service.other',
    ServicePriorityBoarding: 'service.priority_boarding',
    ServiceSpecialAssistance: 'service.special_assistance',
    ServiceSportsEquipment: 'service.sports_equipment',
    ServiceTravellingWithPets: 'service.travelling_with_pets',
    ServiceUpgradeBaggage: 'service.upgrade_baggage',
    ServicePackage: 'service_package',
    Subscription: 'subscription'
};
/**
 * Check if a given object implements the ShoppingBasketValidationError interface.
 */
export function instanceOfShoppingBasketValidationError(value) {
    if (!('itemCategory' in value) || value['itemCategory'] === undefined)
        return false;
    if (!('itemIndex' in value) || value['itemIndex'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
export function ShoppingBasketValidationErrorFromJSON(json) {
    return ShoppingBasketValidationErrorFromJSONTyped(json, false);
}
export function ShoppingBasketValidationErrorFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'itemCategory': json['item_category'],
        'itemIndex': json['item_index'],
        'message': json['message'],
    };
}
export function ShoppingBasketValidationErrorToJSON(json) {
    return ShoppingBasketValidationErrorToJSONTyped(json, false);
}
export function ShoppingBasketValidationErrorToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'item_category': value['itemCategory'],
        'item_index': value['itemIndex'],
        'message': value['message'],
    };
}
